var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62695 2.25C3.79853 2.25 3.12695 2.92157 3.12695 3.75V14.25C3.12695 15.0784 3.79853 15.75 4.62695 15.75H15.127C15.9554 15.75 16.627 15.0784 16.627 14.25V3.75C16.627 2.92157 15.9554 2.25 15.127 2.25H4.62695ZM13.627 6.375C13.627 6.99632 13.1233 7.5 12.502 7.5C11.8806 7.5 11.377 6.99632 11.377 6.375C11.377 5.75368 11.8806 5.25 12.502 5.25C13.1233 5.25 13.627 5.75368 13.627 6.375ZM15.127 14.25H4.62695V11.6105L7.62698 9.21047L10.9085 11.8357C11.2069 12.0744 11.6371 12.0506 11.9073 11.7803L12.877 10.8107L15.127 13.0606V14.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/imageIcon.0a0f1c8d7c228ec2beec4c3c0d8028b6.svg";
export { ForwardRef as ReactComponent };